module.exports = __webpack_public_path__ + "static/media/image-1200.a4609e16.webp";